import { AccountCode, BrandAndMarketListItem, CardPoolSetting, GuidIdAndLabel } from '../../../integrated-client/models';

export interface IVccCredentialsEditorData {
  id?: string | null;
  cardSupplier?: GuidIdAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  accountCodes?: Array<AccountCode> | null;
  description?: string | null;
  email?: string | null;
  url?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  zip?: string | null;
  disabled?: boolean;
  allowEdit?: boolean;
  effectiveDateFrom?: object | null;
  effectiveDateTo?: object | null;
  password?: string | null;
  agentId?: string | null;
  apiKey?: string | null;
  bookerId?: string | null;
  clientId?: string | null;
  consumer?: string | null;
  server?: string | null;
}

export interface IEditorData {
  vccCredentialsEditorData: IVccCredentialsEditorData;
  validation?: any;
}

export class VccCredentialsEditorData implements IVccCredentialsEditorData {
  id?: string | null;
  cardSupplier?: GuidIdAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  accountCodes?: Array<AccountCode> | null;
  description?: string | null;
  email?: string | null;
  url?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  zip?: string | null;
  disabled?: boolean;
  allowEdit?: boolean;
  effectiveDateFrom?: object | null;
  effectiveDateTo?: object | null;
  password?: string | null;
  agentId?: string | null;
  apiKey?: string | null;
  bookerId?: string | null;
  clientId?: string | null;
  consumer?: string | null;
  server?: string | null;
  username?: string | null;
  organisationId?: string | null;
  merchantId?: string | null;
  bankId?: string | null;
  companyId?: string | null;
  cardPoolsettings?: Array<CardPoolSetting> | null;
}

export class EditorData implements IEditorData {
  vccCredentialsEditorData: IVccCredentialsEditorData;
  validation?: any;

  constructor() {
    this.vccCredentialsEditorData = new VccCredentialsEditorData();
  }
}
